module.exports = __webpack_public_path__ + "img/speed-guarantee-promo.4e6d4a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/speed-guarantee-promo.png
// module id = CaBx
// module chunks = 57